export default "__VITE_ASSET__050edd99__"